import axios from "axios";
import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class PostService extends BaseService {
    static async getPosts(params = {}) {
        const res = await this.get(`/posts`, params);
        return unwrapResponse(res);
    }
    static async getPost(params = {}) {
        const res = await this.get(`/posts/` + params.post_id);
        return unwrapResponse(res);
    }
    static async createPost(params = {}) {
        const res = await this.post(`/posts`, params);
        return unwrapResponse(res);
    }
    static async updatePost(postId, params = {}) {
        const res = await this.post(`/posts/` + postId, params);
        return unwrapResponse(res);
    }
    static async getWorkProcess(params = {}) {
        const res = await this.get(`/categories/1/tree`, params);
        return unwrapResponse(res);
    }
    static async likePost(params = {}) {
        const res = await this.post(`/posts/` + params.post_id + '/like', params);
        return unwrapResponse(res);
    }
    static async getComments(postId, params = {}) {
        const res = await this.get(`/posts/` + postId + `/comments`, params);
        return unwrapResponse(res);
    }
    static async deletePost(postId, params = {}) {
        const res = await this.post(`/posts/${postId}/delete`);
        return unwrapResponse(res);
    }
    static async getUserLikePost(postId, params = {}) {
        const res = await this.get(`/posts/` + postId + `/like/users`, params);
        return unwrapResponse(res);
    }
    static async getUserReadPost(postId, params = {}) {
        const res = await this.get(`/posts/` + postId + `/read/users`, params);
        return unwrapResponse(res);
    }
    static async userReadPost(postId) {
        const res = await this.post(`/posts/` + postId + `/read`);
        return unwrapResponse(res);
    }
    static async uploadFile(params = {}) {
        try {
            const res = await axios.post(this.getUrl(`/media/upload-multiple`), params);
            return unwrapResponse(res);
        }
        catch (e) {
            if (axios.isAxiosError(e) && e.response?.data) {
                const body = e.response.data;
                let message = body.message || "Không thể tải tệp lên.";
                const fieldErrors = body.data;
                if (fieldErrors && typeof fieldErrors === "object") {
                    const firstKey = Object.keys(fieldErrors)[0];
                    const raw = firstKey ? fieldErrors[firstKey] : null;
                    const firstErr = Array.isArray(raw) ? raw[0] : raw;
                    if (firstErr) {
                        message = String(firstErr);
                    }
                }
                return { status: false, message, data: body.data || [] };
            }
            return { status: false, message: "Không thể tải tệp lên.", data: [] };
        }
    }
    static async deleteUploadedMedia(fileId) {
        const res = await this.delete(`/media/${fileId}`);
        return unwrapResponse(res);
    }
    static async votePoll(pollId, params = {}) {
        const res = await this.post(`/polls/` + pollId + `/vote`, params);
        return unwrapResponse(res);
    }
    static async addNewPollOption(pollId, params = {}) {
        const res = await this.post(`/polls/` + pollId + `/add-option`, params);
        return unwrapResponse(res);
    }
    static async toggleNotification(postId, params = {}) {
        const res = await this.post(`/posts/` + postId + `/turn-off-notification`, params);
        return unwrapResponse(res);
    }
    static async getLinkMetadata(params = {}) {
        const res = await this.get(`/posts/get-metadata`, params);
        return unwrapResponse(res);
    }
}
